import { defineMessages } from 'react-intl';

export default defineMessages({
  thisSectionRelatesToExpenses: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.thisSectionRelatesToExpenses',
    defaultMessage: 'This section relates to expenses resulting from your rental vehicle being stolen or damaged.',
  },

  haveYouReceivedAnyCreditOrRefundFromTheServiceProvider: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider',
    defaultMessage: 'Have you received any credit or refund from the service provider?',
  },
  haveYouReceivedAnyCreditOrRefundFromTheRentalVehicleCompany: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider',
    defaultMessage: 'Have you received any credit or refund from the rental vehicle company?',
  },
  amountCreditedOrRefunded: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.amountCreditedOrRefunded',
    defaultMessage: 'Amount credited/refunded',
  },
  expenseFor: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfItem: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  descriptionOfExpense: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  amountClaimed: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.currency',
    defaultMessage: 'Currency',
  },
  isRequired: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  yes: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.no',
    defaultMessage: 'No',
  },
  selectInsuredForExpense: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.selectInsuredForExpense',
    defaultMessage: 'Select the Insured(s) for the expense',
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  descriptionMaxLength: {
    id: 'fastCover.rentalVehicleExcessSCTIStep.descriptionMaxLength',
    defaultMessage: 'Please enter maximum of 150 characters',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.RentalVehicleExcess/messages.js